<template>
  <div>
    <v-container v-if="false" style="min-height: 80vh" class="d-flex flex-column justify-center align-center">
      <v-progress-circular
        :size="70"
        :width="7"
        :color="$store.state.achievement.side_color"
        indeterminate
      ></v-progress-circular>
    </v-container>
    <v-data-iterator
      v-else
      class="d-flex flex-column fill-height"
      :items="achievements"
      hide-default-footer
      :page.sync="page"
      :items-per-page.sync="itemsPerPage"
      :loading="loading"
    >
      <template #default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <card-achievements :achievement="item"/>
          </v-col>
        </v-row>
      </template>
      <v-spacer/>
      <template #no-data>
        <v-alert
            class="my-3 text-center rounded-lg"
            dense
            text
            type="warning"
        >
          В портфолио отсутсвуют достижения.
        </v-alert>
      </template>
      <template #loading>
        <v-card height="454px" class="d-flex flex-column justify-center align-center">
          <v-progress-circular
            :size="65"
            :width="7"
            :color="$store.state.achievement.side_color"
            indeterminate
          ></v-progress-circular>
        </v-card>
      </template>
      <template #footer v-if="achievements.length > 0">
        <v-row
            class="pb-3 px-2 pt-auto"
            align="center"
            justify="center">
          <div class="text-center">
            <v-pagination
              circle
              :color="$store.state.achievement.side_color"
              v-model="page"
              :length="numberOfPages"
              :total-visible="visibleNumberPagesPagination"
            >
            </v-pagination>
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import CardAchievements from "../Cards/CardAchievements";

export default {
  name: "AchievementListTab",

  components: {CardAchievements},

  data() {
    return {
      page: 1,
      loading: true,
    }
  },

  async mounted() {
    await this.gePortfolioAchievements();
    this.loading = false;
  },

  computed: {
    ...mapState({
      achievements: state => state.achievement.portfolioAchievements,
    }),

    numberOfPages () {
      return Math.ceil(this.achievements.length / this.itemsPerPage)
    },

    itemsPerPage() {
      return this.$vuetify.breakpoint.mobile ? 4 : 8;
    },

    visibleNumberPagesPagination() {
      return this.$vuetify.breakpoint.mobile ? 2 : 6;
    },

  },

  methods: {

    ...mapActions({
      gePortfolioAchievements: "achievement/gePortfolioAchievements",
    }),

    updateItemsPerPage (number) {
      this.itemsPerPage = number
    },
  },

}
</script>

<style scoped>
.v-sheet--outlined {
  border-color: #2c662d;
}

.description {
  max-height: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>